export enum BreadcrumbsMode {
    Full,
    BackButtonOnly,
    Hidden,
}
